import React, { Component } from 'react';

class TwitterForm extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }


  render() {
    return (
      <div>
        <form
          style={{ maxWidth: '400px', position: 'relative' }}
          onSubmit={{}}
          method="post"
          className="form__admin  form__admin--greyBg  u-padding-small"
        >

        twitter form

        </form>
      </div>
    );
  }


}


export default TwitterForm;



// WEBPACK FOOTER //
// ./src/cards/templates/RecommendAFriendCard/TwitterForm.js